document.addEventListener("DOMContentLoaded", function () {
    const slickSliderCross = document.querySelector(".cross-sell__slick-slider");
    const duoEnabled = document.querySelector(".cross-sell__section-wrapper--duo");
  
    if (slickSliderCross) {
      const slickConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        appendArrows: '.cross-sell__arrows',
        dots: false,
      };
  
      if (duoEnabled) {
  
        slickConfig.slidesToShow = 2;
        slickConfig.autoplay = false;
        slickConfig.responsive = [
          {
            breakpoint: 1200,
            settings: {
              variableWidth: true,
            },
          },
          {
            breakpoint: 990,
            settings: {
              variableWidth: false,
            },
          },
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
            },
          },
        ];
      }
  
      $(slickSliderCross).slick(slickConfig);
    }
  });
  
